import React, { useState } from "react";
import "./Header.css";

import Bars from "../assets/bars.png";
import { Link } from "react-scroll";

const Header = () => {
  const mobile = window.innerWidth <= 768 ? true : false;
  const [menuOpened, setMenuOpened] = useState(false);
  const value = true;

  return (
    <div className="header">
      <div className="logo-head">
      <img src="https://cdn-icons-png.flaticon.com/256/4669/4669575.png" alt="" className="logo" style={{color:'red'}}/>
      <span style={{color:'white'}}>FIT CLUB</span>
      </div>
      {menuOpened === false && mobile === true ? (
        <div
          style={{
            backgroundColor: "var(--appColor)",
            padding: "0.5rem",
            borderRadius: "5px",
          }}
          onClick={() => setMenuOpened(true)}
        >
          <img
            src={Bars}
            alt=""
            style={{ width: "1.5rem", height: "1.5rem" }}
          />
        </div>
      ) : (
        <ul className="header-menu">
          <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="hero"
              activeClass="active"
              span={value.toString()}
              smooth={true}
            >
              Home
            </Link>
          </li>
          <li>
            {" "}
            <Link
              onClick={() => setMenuOpened(false)}
              to="programs"
              span={value.toString()}
              smooth={true}
            >
              Program
            </Link>
          </li>
          <li>
            {" "}
            <Link
              onClick={() => setMenuOpened(false)}
              to="reasons"
              span={value.toString()}
              smooth={true}
            >
              Why Us
            </Link>
          </li>

          <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="plans"
              span={value.toString()}
              smooth={true}
            >
              Plans
            </Link>
          </li>

          {/* <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="trainers"
              span={value.toString()}
              smooth={true}
            >
              Trainers
            </Link>
          </li> */}
          <li>
            {" "}
            <Link
              onClick={() => setMenuOpened(false)}
              to="testimonials"
              span={value.toString()}
              smooth={true}
            >
              Testimonials
            </Link>{" "}
          </li>
        </ul>
      )}
    </div>
  );
};

export default Header;
